var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelpCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C10.8182 22 9.64778 21.7672 8.55585 21.3149C7.46392 20.8626 6.47177 20.1997 5.63604 19.364C4.80031 18.5282 4.13738 17.5361 3.68508 16.4441C3.23279 15.3522 3 14.1819 3 13C3 11.8181 3.23279 10.6478 3.68508 9.55585C4.13738 8.46392 4.80031 7.47177 5.63604 6.63604C6.47177 5.80031 7.46392 5.13738 8.55585 4.68508C9.64778 4.23279 10.8182 4 12 4C14.3869 4 16.6761 4.94821 18.364 6.63604C20.0518 8.32387 21 10.6131 21 13C21 15.3869 20.0518 17.6761 18.364 19.364C16.6761 21.0518 14.3869 22 12 22Z",
    stroke: "#C0C0C0",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 10.5C9.5 9.11929 10.6193 8 12 8C13.3807 8 14.5 9.11929 14.5 10.5C14.5 11.6046 13.7981 12.5423 12.8126 12.9062C12.3326 13.0823 12 13.5344 12 14.045V14.5",
    stroke: "#C0C0C0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17.5V17.51",
    stroke: "#C0C0C0",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpCircle);
export default __webpack_public_path__ + "static/media/help-circle.1745c270f5e39924cb7f28507993c93b.svg";
export { ForwardRef as ReactComponent };